// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__12Zzv","col":"styles_col__2YiVZ"};